<div class="person-item-list-container">
  <div class="ui secondary menu">
    @for (relationType of relationTypeList; track relationType) {
      <a class="item"
      [ngClass]="{active: selectedRelationType === relationType}" (click)="selectRelationType(relationType)">{{relationType}}</a>
    }
  </div>
  <div class="ui stackable two column grid">
    @for (item of itemsWithRelation; track item) {
      <div class="column">
        <div class="ui segment item-card">
          <div class="image">
          <ui-responsive-image [src]="item.coverImage.url" [size]="{
              width: '100%',
              ratio: item.imageRatio,
              originalWidth: item.coverImage.width,
              originalHeight: item.coverImage.height
            }" [background]="item.coverImage.dormantColor"></ui-responsive-image>
          </div>
          <div class="item-name">{{item.nameCn || item.name}}</div>
          <div class="item-alt-name">{{item.nameCn ? item.name : ''}}</div>
          <div class="extra-info">
            @if (item.type) {
              <div class="ui mini label">{{item.type}}</div>
            }
            @if (item.subType) {
              <div class="ui basic mini label">{{item.subType}}</div>
            }
            @if (item.publicTime) {
              <div class="public-time">{{item.publicTime}}</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
